import { useFetchToCloudFunctionApi } from '@/composables/useFetchToCloudFunctionApi';
import type { ItineraryContactFormRequestBody } from '@/wabunka-src/features/Itinerary/composables/form/itineraryContactForm';

export const useSubmitItineraryContactMutation = () => {
  const { cloudFunctionApiClient } = useFetchToCloudFunctionApi();

  const submitItineraryContactMutate = async (formData: ItineraryContactFormRequestBody): Promise<void> => {
    await cloudFunctionApiClient.post('/wabunkaItineraryContact', formData);
    return;
  };

  return { submitItineraryContactMutate };
};
